module.exports = __webpack_public_path__ + "static/6_1-hammock-50d5276eda04ba8bd99778ae445e657c.svg";